import { render } from "./DADataTable copy.vue?vue&type=template&id=6db148c3"
import script from "./DADataTable copy.vue?vue&type=script&lang=js"
export * from "./DADataTable copy.vue?vue&type=script&lang=js"

import "./DADataTable copy.vue?vue&type=style&index=0&id=6db148c3&lang=scss"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__